// src/CompanyContext.js
import React, { createContext, useState, useEffect } from 'react';
import { getSession } from './utils/SessionUtils';

export const CompanyContext = createContext();

export const CompanyProvider = ({ children }) => {
  const [company, setCompany] = useState(null);
  useEffect(() => {
    let companyValue = getSession("COMPANY");
    console.log("Company value from session:", companyValue);
    setCompany(companyValue);
  }, []);
   
  return (
    <CompanyContext.Provider value={company}>
      {children}
    </CompanyContext.Provider>
  );
};